<template>
    <div class="curtain-grey">
        <RepeatCustom v-if="customState"
                      :repeatType="repeatItem.repeatType"
                      :repeatCycle="repeatItem.repeatCycle"
                      :repeatInfo="repeatItem.repeatInfo"
                      :skipHolidaysState="repeatItem.skipHolidaysState"
                      @closeEvent="switchCustom"
                      @submitEvent="saveRepeat($event)"
        />
        <div class="body-repeat" v-show="!customState">
            <div class="border-repeat">
                <div class="text-title">设置重复</div>
                <div class="items-repeat scrollbar">
                    <div class="item-repeat" v-for="(item) in repeatItems">
                        <div class="my-cursor "
                             :class="{
                            'icon-option-true': item.repeatType === repeatItem.repeatType,
                            'icon-option-false': item.repeatType !== repeatItem.repeatType,
                            }"
                             @click.stop="selectRepeat(item.repeatType)"></div>
                        <div class="text-repeat">{{ item.text }}</div>
                    </div>
                    <div class="item-repeat">
                        <div class="my-cursor "
                             :class="{
                            'icon-option-true': customType.indexOf(repeatItem.repeatType) > -1,
                            'icon-option-false': customType.indexOf(repeatItem.repeatType) === -1
                        }"
                             @click.stop="switchCustom"></div>
                        <div class="text-repeat">自定义重复</div>
                    </div>
                </div>
                <div class="button-items">
                    <div class="button-close my-cursor" @click.stop="close">取消</div>
                    <div class="button-submit my-cursor" @click.stop="submit">保存</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RepeatCustom from "./RepeatCustom";
export default {
    name: "SettingRepeat",
    components: {
        RepeatCustom,
    },
    data(){
        return {
            customState: false,
            repeatItem: {
                repeatType: "",
                repeatCycle: 1,
                repeatInfo: "",
                skipHolidaysState: false,
            },
            repeatItems: [
                {
                    repeatType: "",
                    text: "不重复",
                },{
                    repeatType: "every_day",
                    text: "每天",
                },{
                    repeatType: "work_day",
                    text: "法定工作日",
                },{
                    repeatType: "every_week",
                    text: "每周",
                },{
                    repeatType: "every_month",
                    text: "每月",
                },{
                    repeatType: "every_year",
                    text: "每年",
                },{
                    repeatType: "lunar_year",
                    text: "农历",
                },{
                    repeatType: "i_b_h_s",
                    text: "艾宾浩斯记忆",
                }
            ],
            customType: [
                "month_week",
                "custom_date",
                "custom_day",
                "custom_week",
                "custom_month",
                "custom_year",
            ],
            week: "",
            month: "",
            day: "",
            lunarMonth: "",
            lunarDay: "",
        }
    },
    props: {
        startDate: {
            type: String,
            default: "",
        },
        repeatType: {
            type: String,
            default: "",
        },
        repeatCycle: {
            type: Number,
            default: 1,
        },
        repeatInfo: {
            type: String,
            default: "",
        },
        skipHolidaysState: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        close: function(){
            this.$emit("closeEvent");
        },
        submit: function(){
            this.$emit("submitEvent", this.repeatItem);
            this.close();
        },
        switchCustom: function(){
            this.customState = !this.customState;
        },
        selectRepeat: function(repeatType){
            this.repeatItem.repeatType = repeatType;
            this.repeatItem.repeatCycle = 1;
            this.repeatItem.skipHolidaysState = false;
            if(this.repeatItem.repeatType === "every_week"){
                this.repeatItem.repeatInfo = this.week;
            }else if(this.repeatItem.repeatType === "every_month"){
                this.repeatItem.repeatInfo = this.day;
            }else if(this.repeatItem.repeatType === "every_year"){
                this.repeatItem.repeatInfo = this.month + this.$Utils.addZero(this.day);
            }else if(this.repeatItem.repeatType === "lunar_year"){
                this.repeatItem.repeatInfo = this.lunarMonth + this.$Utils.addZero(this.lunarDay);
            }else{
                this.repeatItem.repeatInfo = "";
            }
        },
        saveRepeat: function(item){
            this.repeatItem.repeatType = item.repeatType;
            this.repeatItem.repeatCycle = item.repeatCycle;
            this.repeatItem.repeatInfo = item.repeatInfo;
            this.repeatItem.skipHolidaysState = item.skipHolidaysState;
        },
        initRepeat: function(targetDate){
            const lunarDate = targetDate.getLunar();

            let week = targetDate.getWeek();
            if(week === 0){
                week = 7
            }
            this.week = week.toString();
            this.month = targetDate.getMonth().toString();
            this.day = targetDate.getDay().toString();
            this.lunarMonth = lunarDate.getMonth().toString();
            this.lunarDay = lunarDate.getDay().toString();

            this.repeatItems.forEach((item)=>{
                if(item.repeatType === "every_week"){
                    item.text = "每周" + targetDate.getWeekInChinese();
                }else if(item.repeatType === "every_month"){
                    item.text = "每月" + this.day + "日";
                }else if(item.repeatType === "every_year"){
                    item.text = "每年" + this.month + "月" + this.day + "日";
                }else if(item.repeatType === "lunar_year"){
                    const lunarDate = targetDate.getLunar();
                    item.text = "农历" + lunarDate.getMonthInChinese() + "月" + lunarDate.getDayInChinese();
                }
            })
        },
    },
    mounted(){
        let targetDate;
        if(this.startDate === ""){
            targetDate = Solar.fromDate(new Date);
        }else{
            targetDate = Solar.fromDate(new Date(this.startDate));
        }
        this.initRepeat(targetDate);
        this.repeatItem.repeatType = this.repeatType;
        this.repeatItem.repeatCycle = this.repeatCycle;
        this.repeatItem.repeatInfo = this.repeatInfo;
        this.repeatItem.skipHolidaysState = this.skipHolidaysState;
    }
}
</script>

<style scoped>
div.body-repeat{
    width: 4.2rem;
    height: auto;
    padding: 0.08rem;
    background: #FFFFFF;
    border-radius: 0.3rem;
    margin: 20vh auto auto;
}
div.border-repeat{
    width: 100%;
    height: auto;
    padding: 0.16rem 0.2rem 0.3rem;
    border: 0.02rem solid #000000;
    border-radius: 0.26rem;
    box-sizing: border-box;
}
div.text-title{
    width: 100%;
    height: 0.22rem;
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    line-height: 0.22rem;
    text-align: center;
}

div.items-repeat{
    width: 100%;
    max-height: 2rem;
    display: flex;
    flex-direction: column;
    gap: 0.24rem;
    margin: 0.24rem auto;
    overflow-y: scroll;
}
div.scrollbar{
    padding-right: 0.1rem;
    overflow-y: scroll;
}
div.scrollbar::-webkit-scrollbar{
    background: transparent;
}
div.item-repeat{
    width: 100%;
    height: 0.24rem;
    display: flex;
    gap: 0.11rem;
    align-items: center;
}

div.icon-option-true, div.icon-option-false{
    width: 0.22rem;
    height: 0.22rem;
}
div.icon-option-true{
    background: url("../../../assets/images/Public/icon-option-true.png");
    background-size: cover;
}
div.icon-option-false{
    background: url("../../../assets/images/Public/icon-option-false.png");
    background-size: cover;
}
div.text-repeat{
    flex: 1;
    font-weight: bold;
    font-size: 0.16rem;
    color: #000000;
    text-align: left;
}

div.button-items{
    width: 100%;
    height: 0.48rem;
    margin-top: 0.4rem;
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
}
div.button-submit, div.button-close{
    width: 1.4rem;
    height: 0.48rem;
    border-radius: 0.38rem;
    border: 0.02rem solid #000000;
    font-size: 0.16rem;
    line-height: 0.43rem;
    text-align: center;
}

div.button-close{
    background: #FFFFFF;
    box-shadow: inset 0 -0.05rem 0 0 #9F9F9F;
    color: #000000;
}
div.button-submit{
    background: #FC8470;
    box-shadow: inset 0 -0.05rem 0 0 #FFF4C9;
    color: #FFFFFF;
}
</style>